/*eslint "no-console": "off"*/
import React from 'react';
import ReactDOM from 'react-dom';
import {ApolloProvider, ApolloClient} from '@apollo/client';
import {InMemoryCache} from '@apollo/client/cache';
import {createUploadLink} from 'apollo-upload-client';
import {ConfigProvider} from 'antd';
import {QueryParamProvider} from 'use-query-params';
import {BrowserRouter as Router, Route} from 'react-router-dom';
import Auth from './views/auth';

const cache = new InMemoryCache({});

const link = createUploadLink({
  uri: '/graphql',
  credentials: 'include',
});

const client = new ApolloClient({
  cache,
  link,
});

const Admin = () => (
  <ApolloProvider client={client}>
    <ConfigProvider>
      <Router>
        <QueryParamProvider ReactRouterRoute={Route}>
          <Auth />
        </QueryParamProvider>
      </Router>
    </ConfigProvider>
  </ApolloProvider>
);

export default Admin;

ReactDOM.render(<Admin />, document.getElementById('auth'));
